import React from "react";
import { ValidatedForm } from "components/forms";
import { payloadBuilder } from "libs";
import { TitoliProfessionaliTFAIndireConfig as Config } from "./TitoliProfessionaliTFAIndireConfig";

export class TitoliProfessionaliTFAIndire extends ValidatedForm {
  constructor(props) {
    super(props);

    const isLode = props.defaultValues?.lode || false;
    const configProps = { ...props, onChangeCheck: this.onChangeCheck };
    const fields = isLode ? Config.getFieldsShort(configProps) : Config.getFieldsFull(configProps);
    const classeConcorso = Config.getCompetitionClass(props.grado);

    const defaultValues = {
      ...Config.default_values,
      ...props.defaultValues,
      classeConcorso,
      grado: props.grado,
    };

    this.state = {
      currentFieldSet: fields,
      currentLode: isLode,
      validationError: null,
      ...defaultValues,
      defaultValues,
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    const { currentLode } = this.state;
    const { courseType } = this.props;

    this.validation = currentLode ? Config.getValidationShort(this, courseType) : Config.getValidationFull(this, courseType);
    this.ERROR_MESSAGES = Config.getErrorMessages(courseType);
  }

  onChangeCheck = (id, value) => {
    const { courseType } = this.props;
    const configProps = { ...this.props, onChangeCheck: this.onChangeCheck };

    if (value === true) {
      this.setState({
        currentFieldSet: Config.getFieldsShort(configProps),
        currentLode: true,
        dateTo: "",
        durata: "",
      });
      this.validation = Config.getValidationShort(this, courseType);
    } else {
      this.setState({
        currentFieldSet: Config.getFieldsFull(configProps),
        currentLode: false,
      });
      this.validation = Config.getValidationFull(this, courseType);
    }
  };

  onSubmit = () => {
    let isValid = false;
    this.setState({ validationError: "" });
    isValid = this.checkValidation();

    return isValid;
  };

  getPayload = () => {
    const { currentLode } = this.state;
    const { qualificationType, qualificationCode, template, extCode } = this.props;

    let payload = payloadBuilder(this.state);

    payload.qualificationType = qualificationType;
    payload.qualificationCode = qualificationCode;
    payload.template = currentLode ? `${template}Lode` : template;
    payload.extCode = extCode;
    payload.lode = currentLode;

    return payload;
  };

  render() {
    const { defaultValues, currentFieldSet, validationError } = this.state;
    const { code } = this.renderFields(currentFieldSet, defaultValues, true);
    return (
      <>
        {code}
        {validationError && <span className="text-danger">{validationError}</span>}
      </>
    );
  }
}
